/* src/app/shared/components/user-block/user-block.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.user-block {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
}
@media screen and (min-width: 48rem) {
  .user-block {
    justify-content: flex-end;
  }
}
.user-block .greeting,
.user-block .account {
  padding: 0 1em;
  line-height: 1;
  text-align: right;
}
.user-block .greeting {
  border-right: solid thin #595555;
}
.user-block .account .userName {
  font-weight: 700;
  text-transform: uppercase;
}
.user-block .user-information {
  display: none;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  margin: 0 1em 0 2em;
}
@media screen and (min-width: 48rem) {
  .user-block .user-information {
    display: flex;
  }
}
.user-block .user-information .username {
  font-family: "Roboto Flex", sans-serif;
  font-size: 1.5em;
  font-weight: 700;
}
.user-block .user-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #004791;
  color: white;
  position: relative;
  height: 5rem;
  width: 5rem;
  font-size: 2em;
  font-family: "Roboto Flex", sans-serif;
  text-transform: uppercase;
  cursor: pointer;
}
.user-block .user-icon.is-admin::after {
  content: "\e8e8";
  font-family: "Material Icons";
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 0.6em;
  color: #ffb500;
}
:host {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
/*# sourceMappingURL=user-block.component.css.map */
